<script>
export default {
    name: "IconLogo"
}
</script>

<template>
    <svg class="img-fluid" id="outputsvg" xmlns="http://www.w3.org/2000/svg"
       viewBox="0 0 2650 2650">
        <g id="l2b8UpU7IJtkQC9zIzvIovG" fill="none" style="transform: none;">
            <g style="transform: none;">
                <path id="pMYVIIjUf" d="M0 1325 l0 -1325 1325 0 1325 0 0 1325 0 1325 -1325 0 -1325 0 0 -1325z"></path>
            </g>
        </g>
        <g id="l5BvDnHpgXyHYC79VxIg1gP" fill="rgb(255,255,255)" style="transform: none;">
            <g style="transform: none;">
                <path id="p9T1Zdxgv"
                      d="M106 2600 c5 -5 93 -11 199 -12 l190 -3 5 -547 5 -547 70 -53 c39 -30 127 -98 197 -151 70 -53 129 -97 132 -97 3 0 6 315 6 700 l0 700 30 0 30 0 0 -961 0 -960 32 -27 c18 -15 55 -47 83 -72 28 -25 66 -58 85 -74 39 -33 37 -16 39 -275 l1 -193 42 38 c125 110 230 205 285 258 l63 59 2 1101 3 1101 30 0 30 0 3 -842 2 -842 143 102 c78 56 157 113 175 127 l32 24 0 135 0 136 80 55 80 55 2 525 3 525 173 3 c103 1 172 6 172 12 0 6 -71 10 -185 10 l-185 0 0 -528 0 -528 -85 -60 -85 -59 0 -134 c0 -115 -2 -136 -17 -147 -10 -8 -70 -51 -133 -96 -63 -45 -116 -86 -118 -90 -19 -43 -22 84 -22 817 l0 825 -140 0 -140 0 0 -395 c0 -217 -4 -395 -8 -395 -5 0 -76 31 -158 68 l-149 69 -3 326 -2 327 -110 0 -110 0 -2 -685 -3 -685 -75 58 c-41 32 -115 89 -165 126 -49 38 -96 76 -102 84 -10 12 -13 139 -13 559 l0 543 -212 0 c-138 0 -209 -3 -202 -10z m972 -340 l3 -325 62 -30 62 -30 1 -683 c1 -375 -1 -682 -3 -682 -3 0 -49 37 -104 83 l-98 82 -1 958 0 958 38 -3 37 -3 3 -325z m499 -765 c2 -851 0 -1093 -10 -1105 -7 -8 -62 -60 -122 -115 -60 -55 -129 -118 -153 -140 -24 -22 -48 -41 -53 -43 -5 -2 -9 345 -9 882 0 615 3 886 11 886 5 0 29 -8 52 -19 23 -10 63 -28 89 -40 26 -11 52 -21 57 -21 8 0 11 128 11 405 l0 406 63 -3 62 -3 2 -1090z"></path>
                <path id="pxwZrdRL6"
                      d="M1884 1617 c-2 -7 -3 -71 -2 -142 2 -92 7 -130 16 -133 9 -3 12 30 12 142 0 94 -4 146 -10 146 -6 0 -13 -6 -16 -13z"></path>
                <path id="p3n8dlFZm"
                      d="M1847 1573 c-11 -11 -8 -273 3 -273 6 0 10 53 10 140 0 77 -1 140 -3 140 -2 0 -7 -3 -10 -7z"></path>
                <path id="pdJIdcZG7"
                      d="M1800 1390 c0 -87 4 -140 10 -140 6 0 10 53 10 140 0 87 -4 140 -10 140 -6 0 -10 -53 -10 -140z"></path>
            </g>
        </g>
    </svg>
</template>

<style scoped>

</style>
